<template>
  <div id="here" class="card app-center-widget-holder" style="display: none">
    <div class="card-header cardHere">
      <div id="here-content" class="div-here"></div>

      <div>
        <button type="button" class="close" @click="cancelHere()">
          <span>&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";

// const DEFAULT_TOKEN = "c7fab301-31d8-4618-b452-bc82e361d9bf";

export default {
  data() {
    return {
      access_token: process.env.VUE_APP_TOKEN_APIS,
      marker: null,
      urlReverse: "",
      user:{},
      isOpenInformation: false,
    };
  },
  created() {
    this.urlReverse = process.env.VUE_APP_GEOCODING;
  },
  mounted() {
    if (this.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      this.access_token = tokenData.data.access_token;

      this.user = JSON.parse(window.localStorage.getItem("user"));
    }

    let mapcontext = {
      text: "¿Qué hay aquí?",
      callback: this.search,
      index: 3,
    };

    this.map.contextmenu.insertItem(mapcontext, mapcontext.index);

    this.map.on("click", this.search);
  },
  computed: {
    ...mapState(["map"]),
  },
  methods: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    search(e) {
      //Si existe ya un icono dibujado borrar
      /*this.marker = this.$store.state.markerSearcherReverse;
				console.log('MARCADOR');
				console.log(this.marker);*/

      console.log('abrir informacion');
      console.log(this.isOpenInformation);

      if (this.isOpenInformation) {
        $("#here").hide();

        this.marker = this.$store.state.markerSearcherReverse;

        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        /*this.map.removeLayer(this.marker);*/
        this.isOpenInformation = false;
      } else {
        this.isOpenInformation = true;

        var latitud = e.latlng.lat.toFixed(6);
        var longitud = e.latlng.lng.toFixed(6);

        this.$store.commit("SET_LATITUD_GENERAL", latitud);
        this.$store.commit("SET_LONGITUD_GENERAL", longitud);

        let urlSearch = `${this.urlReverse}latlon=${latitud},${longitud}&maps=true&mapsaccount=${this.user.email}`;

        axios.get(urlSearch).then((response) => {
          const data = response.data.length != 0 ? response.data[0] : [];

          const segments = {
            via: "route",
            numero_via: "route_number",
            adminLevel3: "admin_level_3",
            postalCode: "postal_code",
          };

          let dataReverse = response.data;

          let result = dataReverse.results[0];
          let segmentsReverse = result.address_segments;

          let valueRoute = "";
          let valueRouteNumber = "";
          let valueAdminLevel = "";
          let valuePostalCode = "";

          let place_id = result.place_id;
          let address = result.standard_address;

          for (const codesegment in segmentsReverse) {
            var segment = segmentsReverse[codesegment];

            var haveRoute = segment.types.includes(segments.via);
            if (haveRoute) {
              valueRoute = segment.name;
            }
            var haveRouteNumber = segment.types.includes(segments.numero_via);
            if (haveRouteNumber) {
              valueRouteNumber = segment.name;
            }
            var haveAdminLevel3 = segment.types.includes(segments.adminLevel3);
            if (haveAdminLevel3) {
              valueAdminLevel = segment.name;
            }

            var havePostalCode = segment.types.includes(segments.postalCode);
            if (havePostalCode) {
              valuePostalCode = segment.name;
            }

            var havePostalCode = segment.types.includes(segments.postalCode);
            if (havePostalCode) {
              valuePostalCode = segment.name;
            }
          }

          // let id = data.id;
          // let via = data.tipo + " " + data.via + " " + data.puerta;
          // let distrito = data.distrito;
          // let codigo_postal = data.codigo_postal;

          if (result.length == 0) {
            console.log("no hay ningun resultado");

            //this.searchDistritoReverse(latitud, longitud);
          } else {
            $("#here-content").html(
              "<b>" +
                valueRoute +
                " " +
                valueRouteNumber +
                "</b><br>" +
                valueAdminLevel +
                " " +
                valuePostalCode +
                '<br><span class="coordinates">' +
                latitud +
                ", " +
                longitud +
                "</span>"
            );
            $("#here").show();

            var customIcon = new L.Icon({
              iconUrl: require("../../assets/images/icon_marker_2.png"),
              //iconSize: [25, 35],
              iconAnchor: [12, 18],
              className: "iconReverse",
              //popupAnchor: [0, -38]
            });

            this.marker = L.marker([latitud, longitud], {
              icon: customIcon,
            }).addTo(this.map);

            this.$store.commit("setMarkerSearcherReverse", this.marker);

            this.$store.commit("SET_PLACE_ID", place_id);
            this.$store.commit("SET_ADDRESS", address);
          }
        });
      }
    },
    searchDistritoReverse(latitud, longitud) {
      axios
        .get(
          "https://api.geodir.co/geocoder/distritos/v1/findlatlon?geojson=" +
            encodeURIComponent(
              '{"type":"Point","coordinates":[' +
                longitud +
                "," +
                latitud +
                "]}"
            )
        )
        .then((response) => {
          const data = response.data.length != 0 ? response.data[0] : [];

          let distrito = data.distrito;

          if (Object.keys(data).length == 0) {
            $("#here").hide();

            this.marker = this.$store.state.markerSearcherReverse;

            if (this.marker) {
              this.map.removeLayer(this.marker);
            }
          } else {
            this.searchCodigoPostalReverse(latitud, longitud, distrito);
          }
        });
    },
    searchCodigoPostalReverse(latitud, longitud, distrito) {
      axios
        .get(
          "https://api.geodir.co/geocoder/codigo-postal/v1/findlatlon?geojson=" +
            encodeURIComponent(
              '{"type":"Point","coordinates":[' +
                longitud +
                "," +
                latitud +
                "]}"
            )
        )
        .then((response) => {
          const data = response.data.length != 0 ? response.data[0] : [];

          let codigo_postal = data.codigo_postal;

          $("#here-content").html(
            "<b>" +
              distrito +
              "</b><br>" +
              codigo_postal +
              "<br>" +
              latitud +
              ", " +
              longitud
          );
          $("#here").show();

          this.marker = this.$store.state.markerSearcherReverse;

          if (this.marker) {
            this.map.removeLayer(this.marker);
          }

          var customIcon = new L.Icon({
            iconUrl: require("../../assets/images/icon_marker_2.png"),
            //iconSize: [25, 35],
            iconAnchor: [12, 18],
            //popupAnchor: [0, -38]
          });

          this.marker = L.marker([latitud, longitud], {
            icon: customIcon,
          }).addTo(this.map);
          this.$store.commit("setMarkerSearcherReverse", this.marker);
        });
    },
    cancelHere() {
      $("#here").hide();
      this.marker = this.$store.state.markerSearcherReverse;
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
    },
  },
};
</script>

<style >
.app-center-widget-holder {
  position: absolute;
  left: 50%;
  bottom: 0;
  transition: bottom 0.1s linear, margin-bottom 0.1s linear;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 999;
  width: 300px;
  max-width: 100%;
  margin-bottom: 20px;
}

/*#here .card-header {
		padding: 12px;
		border-bottom:0px !important;
		background-color: #fff !important;
		border-radius: 2px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
	}*/

#here .card-header {
  padding: 12px;
  border-bottom: 0px !important;
  background: #2f2f2f !important;
  color: white !important;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.div-here {
  width: 240px;
  float: left;
  font-size: 13px;
  text-align: left;
}

.cardHere .close {
  margin: -5px -8px 0px 0px;
  width: 30px;
  height: 30px;
  float: right;
  color: white;
}

#here-content .coordinates {
  color: #8d8d8d;
}
.iconReverse {
  color: #8d8d8d;
}
</style>
